
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"11","height":"8","viewBox":"0 0 11 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.7664 1.50272C11.0779 1.18582 11.0779 0.672081 10.7662 0.355256C10.4546 0.0384303 9.94943 0.0384901 9.63788 0.35539L4.16364 5.9236L1.36193 3.07566C1.05028 2.75887 0.545096 2.75897 0.233573 3.0759C-0.0779504 3.39283 -0.0778439 3.90657 0.23381 4.22336L3.59977 7.64485C3.9114 7.96163 4.41655 7.96155 4.72808 7.64467L10.7664 1.50272Z","fill":"#3C44FF"}})])
          )
        }
      }
    